<template>
  <el-form ref="form" size="medium" :model="form" :rules="rules" label-width="140px" >
    <el-form-item label-width="80px">
      <p class="form-tip">
        <i class="el-icon-warning"></i> 提交后进入审批状态，此时无法进行结算
      </p>
    </el-form-item>
    <div class="form-title">发票信息</div>
    <el-form-item label="开票方式" prop="openInvoiceType">
      <el-checkbox-group v-model="form.openInvoiceType">
        <el-checkbox :label="1">电子发票</el-checkbox>
        <el-checkbox :label="2">纸质发票</el-checkbox>
      </el-checkbox-group>
    </el-form-item>
    <el-form-item label="开票售后电话" prop="invoiceAfterSalePhone">
      <el-input v-model="form.invoiceAfterSalePhone" placeholder="请输入售后电话" maxlength="11"></el-input>
    </el-form-item>
    <div class="form-title">结算信息</div>
      <el-form-item label="账户类型" prop="accountType">
        <el-input value="对公账户" readonly></el-input>
      </el-form-item>
      <el-form-item label="商户号" prop="pcMerchantId">
        <el-input v-model="form.pcMerchantId" placeholder="请输入商户号" maxlength="200"></el-input>
      </el-form-item>
      <el-form-item label="企业名称" prop="compName">
        <el-input v-model="form.compName" placeholder="请输入企业名称" maxlength="200"></el-input>
      </el-form-item>
      <el-form-item label="统一社会信用代码" prop="creditCode">
        <el-input v-model="form.creditCode" placeholder="请输入统一社会信用代码" maxlength="18"></el-input>
      </el-form-item>
      <!-- <el-form-item label="APP终端号" prop="appTerminalId">
        <el-input v-model="form.appTerminalId" placeholder="请输入APP终端号" maxlength="200"></el-input>
      </el-form-item>
      <el-form-item label="PC商户号" prop="pcMerchantId">
        <el-input v-model="form.pcMerchantId" placeholder="请输入PC商户号" maxlength="200"></el-input>
      </el-form-item>
      <el-form-item label="PC终端号" prop="pcTerminalId">
        <el-input v-model="form.pcTerminalId" placeholder="请输入PC终端号" maxlength="200"></el-input>
      </el-form-item> -->
    
    <div class="form-title">联系人信息</div>
    <el-form-item label="联系人" prop="contactName">
      <el-input v-model="form.contactName" placeholder="请输入联系人" maxlength="50"></el-input>
    </el-form-item>
    <el-form-item label="联系方式" prop="contactWay">
      <el-input v-model="form.contactWay" placeholder="请输入联系方式" maxlength="30"></el-input>
    </el-form-item>
    <el-form-item label="联系邮箱">
      <el-input v-model="form.contactEmail" placeholder="请输入联系邮箱" maxlength="30"></el-input>
    </el-form-item>
    <el-form-item>
      <el-button type="primary" @click="submit">提交</el-button>
      <el-button type="primary" plain @click="cancel">取消</el-button>
    </el-form-item>
  </el-form>
</template>
<script>
const def = {
  id: 0,
  accountType: 1, // 账户类型 
  openInvoiceType: [0], // 发票类型 
  invoiceAfterSalePhone: "", // 发票售后电话 
  pcMerchantId: "", // APP商户号
  compName:"", // 企业名称
  creditCode: "", // 企业统一社会信用代码
  // appTerminalId: "", // APP终端号
  // pcMerchantId: "", // PC商户号
  // pcTerminalId: "", // PC终端号
  contactName: "", // 联系人
  contactWay: "", // 联系方式
  contactEmail: "", // 联系邮箱
}
// this.$store.state.comp.compName
export default {
  props: ["info"],
  data() {
    return {
      form: Object.assign({}, def),
        //   appTerminalId: [{ required: true, message: '请输入APP终端号' }],
        // pcMerchantId: [{ required: true, message: '请输入PC商户号' }],
        // pcTerminalId: [{ required: true, message: '请输入PC终端号' }],
        // creditCode: [{ required: false, message: '请输入统一社会信用代码' }],
      rules: {
          accountType: [{ required: true }],
          openInvoiceType: [{ required: true, type: "array", message: "请选择开票方式" }],
          invoiceAfterSalePhone: [{ required: true, message: '请输入开票售后电话' }],
          pcMerchantId: [{ required: true, message: '请输入商户号' }],
          contactName: [{ required: true, message: '请输入联系人' }],
          contactWay: [{ required: true, message: '请输入联系方式' }],
          compName: [{ required: true, message: '请输入企业名称' }],
          
      }
    }
  },
  mounted() {
    this.form.compName = this.$store.state.comp.compName
    console.log(this.$store.state)
    if (this.info) {
      for (const key in def) {
        this.form[key] = this.info[key];
      }
    }
    if (this.form.openInvoiceType[0] === 0) this.form.openInvoiceType = [1]; // 旧数据没有填过，默认是0
  },
  methods: {
    async submit() {
      const validata = await this.$refs.form.validate().catch(err => {
        console.log(err)
      })
      if(validata){
        const obj = Object.assign({}, this.form);
        const type = obj.openInvoiceType;
        obj.openInvoiceType = type.length === 2 ? 3 : Number(type); // 都选的话type是3
         this.$emit("save", obj);
      }else{
        this.$message.error('请填写完整信息')
      }
    },
    cancel() {
      this.form = Object.assign({}, def);
      this.$emit("cancel");
    }
  }
};
</script>
<style lang="scss">
.form-tip {
  line-height: 1;
  color: #888;
  .el-icon-warning {
    font-size: 18px;
  }
}
.form-title {
  position: relative;
  left: -30px;
  padding-left: 15px;
  margin: 20px 0 15px;
  line-height: 1;
  font-weight: bold;
  &::before {
    content: "";
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    width: 5px;
    background-color: #409eff;
  }
}
.el-form-item {
  max-width: 400px;
}
.test{
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  .el-form-item {
    width: 50%;
  }
}
</style>